import React from 'react';

import { Link } from '@opendoor/atoms/link';

interface CtaAgreementLinkedProps {
  ctaText: string;
  tosAnalyticsName: string;
  privacyAnalyticsName: string;
  tosUrl?: string;
  privacyUrl?: string;
}

export const CtaAgreementLinked: React.FC<CtaAgreementLinkedProps> = ({
  ctaText,
  tosAnalyticsName,
  privacyAnalyticsName,
  tosUrl = 'https://www.opendoor.com/w/terms',
  privacyUrl = 'https://www.opendoor.com/w/privacy',
}) => (
  <>
    By pressing &ldquo;{ctaText},&rdquo; I agree to Opendoor&rsquo;s{' '}
    <Link
      analyticsName={tosAnalyticsName}
      href={tosUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Opens a new page with Opendoor’s terms of service"
    >
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link
      analyticsName={privacyAnalyticsName}
      href={privacyUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Opens a new page with Opendoor’s privacy policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
